$(document).ready(function () {
    $('.marquee-left').marquee({
      direction: 'left',
      duration: 40000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
    });

  $(".slider-list").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });
  
  $(".announcement-slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });

  $(".categories-section-main .categories-slider").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });
  
  $(".products-slider").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".categories-center-slide").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    dots: false,    
    centerPadding: '480px',
    autoplay: true,
    autoplaySpeed: 2000
  });

  $(".reviews-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });
  
});


// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");



// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
          $('body').removeClass('open-popup');
      }, 400);
  }
});


$(document).on('click', '.sm_open', function() {
  $('body').addClass('open-popup');
});

$(document).on('click', '.sm_close', function() {
  $('body').removeClass('open-popup');
});


// load more functionality 

// (function () {
//   const btn = document.getElementById('LoadMoreBtn');
//   if (!btn) return;

//   const productGrid = document.getElementById('product-grid');
//   const countEl = document.getElementById('LoadMoreCount');
//   const container = document.getElementById('LoadMoreContainer');

//   let currentUrl = btn.dataset.nextUrl;
//   const total = parseInt(btn.dataset.total, 10);
//   const perPage = parseInt(btn.dataset.perPage, 10);

//   btn.addEventListener('click', async function () {
//     if (!currentUrl) return;

//     // Set loading state
//     btn.classList.add('loading');
//     btn.disabled = true;

//     try {
//       const response = await fetch(currentUrl);
//       if (!response.ok) throw new Error('Network response was not ok');

//       const html = await response.text();
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');

//       // Get new product items
//       const newItems = doc.querySelectorAll('#product-grid .grid__item');
//       newItems.forEach(function (item) {
//         productGrid.appendChild(item);
//       });

//       // Re-trigger scroll animations if enabled
//       if (typeof initializeScrollAnimationTrigger === 'function') {
//         initializeScrollAnimationTrigger();
//       }

//       // Find next page URL from the fetched page
//       const nextBtn = doc.querySelector('[data-next-url]');
//       const nextPaginationLink = doc.querySelector('.pagination .pagination__item--next a');

//       if (nextPaginationLink) {
//         currentUrl = nextPaginationLink.getAttribute('href');
//       } else {
//         currentUrl = null;
//       }

//       // Update count text
//       const currentlyShown = productGrid.querySelectorAll('.grid__item').length;
//       if (countEl) {
//         countEl.textContent = 'Showing ' + Math.min(currentlyShown, total) + ' of ' + total + ' products';
//       }

//       // Hide button if no more pages
//       if (!currentUrl) {
//         btn.style.display = 'none';
//         if (countEl) {
//           countEl.textContent = 'All ' + total + ' products loaded';
//         }
//       } else {
//         btn.dataset.nextUrl = currentUrl;
//       }
//     } catch (error) {
//       console.error('Load more failed:', error);
//     } finally {
//       btn.classList.remove('loading');
//       btn.disabled = false;
//     }
//   });
// })();

// (function () {
//   const btn = document.getElementById('LoadMoreBtn');
//   if (!btn) return;

//   const productGrid = document.getElementById('product-grid');
//   const countEl = document.getElementById('LoadMoreCount');

//   let currentUrl = btn.dataset.nextUrl;
//   const total = parseInt(btn.dataset.total, 10);
//   const perPage = parseInt(btn.dataset.perPage, 10);

//   // ✅ FIX: Target the <ul> inside the grid, not the grid container itself
//   const gridList = productGrid.querySelector('ul.grid.product-grid');

//   btn.addEventListener('click', async function () {
//     if (!currentUrl) return;

//     btn.classList.add('loading');
//     btn.disabled = true;

//     try {
//       const response = await fetch(currentUrl);
//       if (!response.ok) throw new Error('Network response was not ok');

//       const html = await response.text();
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');

//       // ✅ FIX: Get items from the <ul> inside the fetched page's grid
//       const fetchedGridList = doc.querySelector('#product-grid ul.grid.product-grid');
//       const newItems = fetchedGridList
//         ? fetchedGridList.querySelectorAll(':scope > .grid__item')
//         : doc.querySelectorAll('#product-grid .grid__item');

//       newItems.forEach(function (item) {
//         // ✅ FIX: Append to the <ul>, not the outer container
//         if (gridList) {
//           gridList.appendChild(item);
//         } else {
//           productGrid.appendChild(item);
//         }
//       });

//       // Re-trigger scroll animations if enabled
//       if (typeof initializeScrollAnimationTrigger === 'function') {
//         initializeScrollAnimationTrigger();
//       }

//       // Find next page URL from the fetched page
//       const nextPaginationLink = doc.querySelector('.pagination .pagination__item--next a');
//       currentUrl = nextPaginationLink ? nextPaginationLink.getAttribute('href') : null;

//       // Update count text
//       const currentlyShown = gridList
//         ? gridList.querySelectorAll(':scope > .grid__item').length
//         : productGrid.querySelectorAll('.grid__item').length;

//       if (countEl) {
//         countEl.textContent = !currentUrl
//           ? 'All ' + total + ' products loaded'
//           : 'Showing ' + Math.min(currentlyShown, total) + ' of ' + total + ' products';
//       }

//       // Hide button if no more pages
//       if (!currentUrl) {
//         btn.style.display = 'none';
//       } else {
//         btn.dataset.nextUrl = currentUrl;
//       }

//     } catch (error) {
//       console.error('Load more failed:', error);
//     } finally {
//       btn.classList.remove('loading');
//       btn.disabled = false;
//     }
//   });
// })();

(function () {
  const productGrid = document.getElementById('product-grid');
  const countEl = document.getElementById('LoadMoreCount');
  const btn = document.getElementById('LoadMoreBtn');

  if (!productGrid || !btn) return;

  const gridList = productGrid.querySelector('ul.grid.product-grid');
  const total = parseInt(btn.dataset.total, 10);
  const perPage = parseInt(btn.dataset.perPage, 10);

  if (btn) btn.style.display = 'none';

  let currentPage = 2;
  let isFetching = false;
  let observer = null;
  let allLoaded = false;

  // ✅ Preserve ALL existing URL params (q, options, sort_by, filters, etc.)
  // Just swap out the `page` param — works for both collection & search pages
  function buildPageUrl(page) {
    const params = new URLSearchParams(window.location.search);
    params.set('page', page);
    return window.location.pathname + '?' + params.toString();
  }

  // Spinner
  const spinner = document.createElement('div');
  spinner.id = 'infinite-scroll-spinner';
  spinner.innerHTML = `<span class="load-more-spinner" aria-hidden="true"></span>`;
  spinner.style.cssText = 'display:none; text-align:center; padding:20px;';
  productGrid.parentNode.insertBefore(spinner, productGrid.nextSibling);

  function getLastCard() {
    const container = gridList || productGrid;
    const allItems = container.querySelectorAll(':scope > .grid__item');
    if (!allItems.length) return null;
    const lastItem = allItems[allItems.length - 1];
    // Fallback to the li itself if .card__content doesn't exist (articles/pages)
    return lastItem.querySelector('.card__content') || lastItem;
  }

  function observeLastCard() {
    if (observer) observer.disconnect();
    if (allLoaded) return;

    const lastCard = getLastCard();
    if (!lastCard) return;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            loadMore();
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: 0.5,
      }
    );

    observer.observe(lastCard);
  }

  async function loadMore() {
    if (isFetching || allLoaded) return;

    isFetching = true;
    spinner.style.display = 'block';

    const urlToFetch = buildPageUrl(currentPage);
    // console.log('Fetching page:', currentPage, urlToFetch);

    try {
      const response = await fetch(urlToFetch);
      if (!response.ok) throw new Error('Network error: ' + response.status);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // ✅ Works for both collection page (ul.grid.product-grid) and search page
      const fetchedGridList = doc.querySelector('#product-grid ul.grid.product-grid');
      const newItems = fetchedGridList
        ? fetchedGridList.querySelectorAll(':scope > .grid__item')
        : doc.querySelectorAll('#product-grid .grid__item');

      if (newItems.length === 0) {
        allLoaded = true;
        if (countEl) countEl.textContent = 'All ' + total + ' results loaded';
        return;
      }

      newItems.forEach(function (item) {
        if (gridList) {
          gridList.appendChild(item);
        } else {
          productGrid.appendChild(item);
        }
      });

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger();
      }

      currentPage++;

      const container = gridList || productGrid;
      const currentlyShown = container.querySelectorAll(':scope > .grid__item').length;

      if (currentlyShown >= total) {
        allLoaded = true;
        if (countEl) countEl.textContent = 'All ' + total + ' results loaded';
        return;
      }

      if (countEl) {
        countEl.textContent = 'Showing ' + currentlyShown + ' of ' + total + ' results';
      }

      observeLastCard();

    } catch (error) {
      console.error('Infinite scroll failed:', error);
      observeLastCard(); // retry on next scroll
    } finally {
      isFetching = false;
      spinner.style.display = 'none';
    }
  }

  const totalPages = Math.ceil(total / perPage);
  if (currentPage <= totalPages) {
    observeLastCard();
  }

})();



// Navigation Click to hover


// Desktop Mega Menu - Hover behavior
document.querySelectorAll('header-menu details.mega-menu').forEach((details) => {
  const summary = details.querySelector('summary');
  let closeTimeout;

  details.addEventListener('mouseenter', () => {
    clearTimeout(closeTimeout);

    // Close all other open mega menus first
    document.querySelectorAll('header-menu details.mega-menu[open]').forEach((openDetails) => {
      if (openDetails !== details) {
        const openSummary = openDetails.querySelector('summary');
        openDetails.removeAttribute('open');
        openDetails.classList.remove('menu-opening');
        openSummary.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mega-menu-open');
      }
    });

    // Open this menu with all required classes/attributes
    details.setAttribute('open', '');
    details.classList.add('menu-opening');
    summary.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mega-menu-open');
  });

  details.addEventListener('mouseleave', () => {
    closeTimeout = setTimeout(() => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      summary.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mega-menu-open');
    }, 100); // small delay prevents flicker when moving between menu and dropdown
  });

  // Prevent click from toggling (let hover handle it)
  summary.addEventListener('click', (e) => {
    e.preventDefault();
  });
});


// Close header drawer when search modal opens
document.addEventListener('DOMContentLoaded', function () {
  const searchDetails = document.querySelector('.header__search details');
  const drawerDetails = document.querySelector('#Details-menu-drawer-container');
  const headerDrawer = document.querySelector('header-drawer');

  if (searchDetails) {
    searchDetails.addEventListener('toggle', function () {
      if (searchDetails.hasAttribute('open')) {
        // Search just opened — close the drawer if it's open
        if (drawerDetails && drawerDetails.hasAttribute('open')) {
          const drawerSummary = drawerDetails.querySelector('summary');

          // Use HeaderDrawer's closeMenuDrawer if available
          if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function') {
            headerDrawer.closeMenuDrawer(new Event('close'), drawerSummary);
          } else {
            // Fallback: manually close
            drawerDetails.removeAttribute('open');
            document.body.classList.remove(
              'overflow-hidden-tablet',
              'overflow-hidden-desktop',
              'mobile-drawer-menu-open'
            );
          }
        }
      }
    });
  }
});


// custom functionality 

  $('#engraving-text-front').attr('type', 'hidden');
  $('#engraving-text-back').attr('type', 'hidden');
  $('#engraving-text-front-label').hide();
  $('#engraving-text-back-label').hide();
    
  // Handle Front
  $('#select-engraving-font-front').change(function(){
    var engTextFront = $('#engraving-text-front');
    var engTextLabelFront = $('#engraving-text-front-label');
    var engFontFront = $(this);
    var selectedFontFront = engFontFront.children("option:selected").data('fontname');

    if (selectedFontFront == "No Engraving"){
      engTextLabelFront.hide()
      engTextFront.attr('type', 'hidden');
      engFontFront.attr('required', '');
    } else {
      engTextLabelFront.show()
      engTextFront.css({'font-family': selectedFontFront, 'font-size': '18pt'});
      engTextFront.attr('type', 'text');
      engTextFront.attr('required', 'required');
    }
  });
  
  // Handle Back
  $('#select-engraving-font-back').change(function(){
    var engTextBack = $('#engraving-text-back');
    var engTextLabelBack = $('#engraving-text-back-label');
    var engFontBack = $(this);
    var selectedFontBack = engFontBack.children("option:selected").data('fontname');

    if (selectedFontBack == "No Engraving"){
      engTextLabelBack.hide()
      engTextBack.attr('type', 'hidden');
      engFontBack.attr('required', '');
    } else {
      engTextLabelBack.show()
      engTextBack.css({'font-family': selectedFontBack, 'font-size': '18pt'});
      engTextBack.attr('type', 'text');
      engTextBack.attr('required', 'required');
    }
  });


  // previous back button functionality 

  document.addEventListener("DOMContentLoaded", function () {

    const backBtn = document.getElementById("customBackBtn");

    backBtn ? backBtn.addEventListener("click", function () {

      const previousPage = sessionStorage.getItem("previousPage");

      // If previous page exists and not current page
      if (
        previousPage &&
        previousPage !== window.location.href
      ) {
        window.location.href = previousPage;
      } else {
        // Fallback to homepage
        window.location.href = "{{ routes.root_url }}";
      }

    }) : '';

  });


  document.querySelector("[name='add']")? document.querySelector("[name='add']").removeAttribute("style"):'';


  // make apppoinment btn event

  let btn = document.querySelector(".js-make-appoinment-btn");
  btn ? btn.addEventListener("click", () => {
    document.querySelector(".servicify-popup-calendar-button").click();
  }) : ''